import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "ids", "disabled", "hasChevron", "onClick", "overTintedBackground", "ariaLabel", "role", "styleSheet"];
import React from 'react';
import { setPropTypes, PropTypes } from 'proper-types';
import { compose, defaultProps, setDisplayName, withProps } from 'recompose';
import omitProps from '@hocs/omit-props';
import wrapOverridableComponent from '@bubble-ui/hoc-wrap-overridable-component';
import LinkSecondary from '@bubble-ui/molecule-link-detail';
import View from '@bubble-ui/primitive-view';
import ActionIconChevronRight from '@bubble-ui/icon-action-chevron-right';
import getDefaultStyleSheet from './getDefaultStylesheet';

var getIds = function getIds(_ref) {
  var id = _ref.id;
  return {
    ids: id ? {
      root: id,
      text: "".concat(id, "__text"),
      chevron: "".concat(id, "__chevron")
    } : {}
  };
};

var FieldLink = function FieldLink(_ref2) {
  var children = _ref2.children,
      ids = _ref2.ids,
      disabled = _ref2.disabled,
      hasChevron = _ref2.hasChevron,
      onClick = _ref2.onClick,
      overTintedBackground = _ref2.overTintedBackground,
      ariaLabel = _ref2.ariaLabel,
      role = _ref2.role,
      _ref2$styleSheet = _ref2.styleSheet,
      rootStyle = _ref2$styleSheet.rootStyle,
      chevronWrapperStyle = _ref2$styleSheet.chevronWrapperStyle,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(View, {
    id: ids.root,
    style: rootStyle
  }, children && /*#__PURE__*/React.createElement(LinkSecondary, _extends({
    overTintedBackground: overTintedBackground,
    isWide: true,
    disabled: disabled,
    id: ids.text,
    inParagraph: true,
    onPress: onClick,
    ariaLabel: ariaLabel,
    role: role
  }, props), children), hasChevron && /*#__PURE__*/React.createElement(View, {
    style: chevronWrapperStyle
  }, /*#__PURE__*/React.createElement(ActionIconChevronRight, {
    disabled: disabled,
    id: ids.chevron,
    colorToken: overTintedBackground ? 'colors/text/default' : 'colors/text/accent',
    colorTokenArgs: {
      interactiveState: disabled ? 'disabled' : 'default'
    }
  })));
};

export default compose(setDisplayName('FieldLink'), defaultProps({
  active: false
}), setPropTypes({
  active: PropTypes.bool,
  overTintedBackground: PropTypes.bool,
  arrow: PropTypes.string,
  fieldLink: PropTypes.string,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  role: PropTypes.string
}), wrapOverridableComponent('Field.FieldLink', getDefaultStyleSheet), withProps(getIds), omitProps('id', 'active'))(FieldLink);
//# sourceMappingURL=index.js.map